import { render, staticRenderFns } from "./material_list.vue?vue&type=template&id=672c87bf&scoped=true&"
import script from "./material_list.vue?vue&type=script&lang=js&"
export * from "./material_list.vue?vue&type=script&lang=js&"
import style0 from "./material_list.vue?vue&type=style&index=0&id=672c87bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c87bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('672c87bf')) {
      api.createRecord('672c87bf', component.options)
    } else {
      api.reload('672c87bf', component.options)
    }
    module.hot.accept("./material_list.vue?vue&type=template&id=672c87bf&scoped=true&", function () {
      api.rerender('672c87bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_activity/components/material_list.vue"
export default component.exports